module.exports = __webpack_public_path__ + "static/media/degas-13.38e9decc.jpeg";